<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">กะพนักงาน (Parking Shift)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">
        ดูยอดระบบ (fee+vat) เทียบยอดที่ยืนยันตอนปิดกะ — อ่านอย่างเดียว
      </p>
    </div>
    <button type="button" (click)="onRefresh()" title="รีเฟรชข้อมูล"
      class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
      <span class="material-icons">refresh</span>
    </button>
  </div>

  <div
    class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col xl:flex-row xl:items-center justify-between gap-4">
      <div>
        <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <span class="material-icons text-amber-500">schedule</span>รายการกะ
        </h3>
        <span *ngIf="siteState.selectedSite()?.name"
          class="inline-flex items-center gap-1 mt-2 px-2.5 py-1 rounded-full bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 text-xs font-bold">
          <span class="material-icons text-[14px]">local_parking</span>{{ siteState.selectedSite()?.name }}
        </span>
      </div>

      <div class="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-3">
        <div class="flex items-center gap-2">
          <label class="text-[11px] font-bold text-slate-400 uppercase tracking-wider whitespace-nowrap">
            เปิดจาก <span class="text-rose-500">*</span>
          </label>
          <input type="date" [(ngModel)]="openDateFrom" (ngModelChange)="onFilterChange()" required
            class="px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <div class="flex items-center gap-2">
          <label class="text-[11px] font-bold text-slate-400 uppercase tracking-wider whitespace-nowrap">
            ถึง <span class="text-rose-500">*</span>
          </label>
          <input type="date" [(ngModel)]="openDateTo" (ngModelChange)="onFilterChange()" required
            class="px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200" />
        </div>
        <select [(ngModel)]="statusFilter" (ngModelChange)="onFilterChange()"
          class="px-3 py-2 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-semibold outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
          <option value="">สถานะทั้งหมด</option>
          <option value="open">เปิดอยู่</option>
          <option value="closed">ปิดแล้ว</option>
        </select>
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()"
        [class.pointer-events-none]="isLoading()">
        <thead class="sticky top-0 z-20 bg-white/95 dark:bg-slate-800/95 border-b border-slate-100 dark:border-slate-700">
          <tr class="text-xs font-bold text-slate-400 uppercase tracking-widest">
            <th class="p-4">รหัสกะ</th>
            <th class="p-4">คนเปิดกะ</th>
            <th class="p-4">เปิด</th>
            <th class="p-4">ปิด</th>
            <th class="p-4 text-center">สถานะ</th>
            <th class="p-4 text-right">ยอดระบบ</th>
            <th class="p-4 text-right">ยืนยัน Cash</th>
            <th class="p-4 text-right">ยืนยัน QR</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-50 dark:divide-slate-700">
          <tr *ngFor="let item of items(); trackBy: trackById" (click)="openDetail(item)"
            class="hover:bg-amber-50/40 dark:hover:bg-slate-700/40 transition-all cursor-pointer">
            <td class="p-4">
              <span
                class="px-2.5 py-1 rounded-lg bg-sky-50 dark:bg-sky-900/20 text-sky-600 dark:text-sky-400 text-xs font-bold font-mono">
                {{ item.shiftCode || '—' }}
              </span>
            </td>
            <td class="p-4 font-semibold text-slate-700 dark:text-slate-200">{{ item.openUserName || '—' }}</td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">
              {{ item.openDate | date:'dd/MM/yyyy HH:mm':'':'en-GB' }}
            </td>
            <td class="p-4 text-xs text-slate-500 whitespace-nowrap">
              {{ item.closeDate ? (item.closeDate | date:'dd/MM/yyyy HH:mm':'':'en-GB') : '—' }}
            </td>
            <td class="p-4 text-center">
              <span class="inline-flex px-2.5 py-1 rounded-full text-[11px] font-bold"
                [ngClass]="item.isOpen
                  ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                  : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'">
                {{ item.isOpen ? 'เปิด' : 'ปิด' }}
              </span>
            </td>
            <td class="p-4 text-right font-black text-slate-800 dark:text-slate-100 whitespace-nowrap">
              {{ formatMoney(item.systemTotalAmount) }}
            </td>
            <td class="p-4 text-right text-slate-600 dark:text-slate-300 whitespace-nowrap">
              {{ formatMoney(item.declaredCash) }}
            </td>
            <td class="p-4 text-right text-slate-600 dark:text-slate-300 whitespace-nowrap">
              {{ formatMoney(item.declaredQr) }}
            </td>
          </tr>
          <tr *ngIf="!selectedSiteId && !isLoading()">
            <td colspan="8" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">location_off</span>
              <p class="font-bold">กรุณาเลือกลานจาก Sidebar</p>
            </td>
          </tr>
          <tr *ngIf="selectedSiteId && !isLoading() && items().length === 0">
            <td colspan="8" class="py-20 text-center text-slate-400">
              <span class="material-icons text-4xl mb-2 opacity-40 block">search_off</span>
              <p class="font-bold">ไม่พบข้อมูลกะในช่วงที่เลือก</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      class="px-6 py-4 border-t border-slate-100/70 dark:border-slate-700 flex flex-col md:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-sm text-slate-500 font-medium">
        <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems() | number }} รายการ</span>
        <select (change)="onPageSizeChange($event)" [ngModel]="pageSize()"
          class="bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-sm rounded-lg font-bold px-2 py-1 outline-none focus:ring-2 focus:ring-amber-200 cursor-pointer">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
        </select>
      </div>
      <div class="flex items-center gap-2">
        <button type="button" (click)="setPage(currentPage() - 1)" [disabled]="currentPage() === 1"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_left</span>
        </button>
        <button type="button" *ngFor="let page of pagesArray" (click)="setPage(page)"
          class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all cursor-pointer"
          [ngClass]="page === currentPage() ? 'bg-amber-400 text-white shadow-sm' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700'">
          {{ page }}
        </button>
        <button type="button" (click)="setPage(currentPage() + 1)"
          [disabled]="currentPage() === totalPages() || totalPages() === 0"
          class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-700 hover:text-amber-500 disabled:opacity-30 transition-all cursor-pointer">
          <span class="material-icons text-sm">chevron_right</span>
        </button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-shift-detail *ngIf="isModalOpen()" [shiftId]="selectedId()" [siteId]="selectedSiteId"
  (close)="closeModal()">
</app-modal-parking-shift-detail>
